import { SITE_URL, SITE_NAME, DEFAULT_OG_IMAGE } from '../components/feature/Seo';

export const PERSON_JSONLD = {
  '@context': 'https://schema.org',
  '@type': 'Person',
  '@id': `${SITE_URL}/#person`,
  name: 'Gerald Fasching',
  url: SITE_URL,
  image: DEFAULT_OG_IMAGE,
  jobTitle: 'Business & Personal Coach, Trainer & Mentor',
  description:
    'Gerald Fasching begleitet Führungskräfte, Unternehmer:innen und Privatpersonen mit dem BHS-Modell - Business, Human, Spirit - in Coaching, Training und alchemistischen Kamingesprächen.',
  knowsAbout: [
    'Business Coaching',
    'Personal Coaching',
    'Persönlichkeitscoaching',
    'Privates Coaching',
    'Führungskräfte-Coaching',
    'Executive Coaching',
    'Mentoring',
    'Organisationsentwicklung',
    'Persönlichkeitsentwicklung',
    'Bewusstseinsarbeit',
    'Lebensthemen & Sinnfindung',
    'BHS-Modell',
    'Alchemistische Kamingespräche',
  ],
  sameAs: [],
};

export const ORGANIZATION_JSONLD = {
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  '@id': `${SITE_URL}/#organization`,
  name: SITE_NAME,
  url: SITE_URL,
  logo: `${SITE_URL}/images/logo/logo.png`,
  image: DEFAULT_OG_IMAGE,
  description:
    'Premium Coaching, Training & Mentoring nach dem BHS-Modell - Business, Human, Spirit. Business Coaching für Führungskräfte und Unternehmer:innen sowie Personal Coaching für Privatpersonen, die in Klarheit, Sinn und persönliche Entfaltung gehen wollen.',
  founder: { '@id': `${SITE_URL}/#person` },
  areaServed: [
    { '@type': 'Country', name: 'Österreich' },
    { '@type': 'Country', name: 'Deutschland' },
    { '@type': 'Country', name: 'Schweiz' },
  ],
  serviceType: [
    'Business Coaching',
    'Personal Coaching',
    'Persönlichkeitscoaching',
    'Führungskräfte-Training',
    'Executive Mentoring',
    'Alchemistische Kamingespräche',
    'Organisationsentwicklung',
  ],
};

export const WEBSITE_JSONLD = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${SITE_URL}/#website`,
  url: SITE_URL,
  name: SITE_NAME,
  inLanguage: 'de-AT',
  publisher: { '@id': `${SITE_URL}/#organization` },
};
